import React, { useState, useEffect, useMemo } from 'react';
// import { appInsights, reactPlugin } from '../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { SelectChangeEvent } from '@mui/material';
import { OptionProps } from './../../view-models';
import { TextComponent, SelectComponent } from '../uiComponents';
import Button from '@mui/material/Button';
import { gritComponentStyles } from './gritComponentStyles';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import { useSelector } from 'react-redux';
import { getClaimsDropdownList, getClaims } from '../../store';
import { ClaimComponent } from '../gritComponents';
import { init_Claim, init_DisplayClaim } from '../../xmlParsing/initInterfaces';
import { Claim, DisplayClaim } from '../../xmlParsing/interfaces';
import ShowClaimComponent from './showClaim';
import { validateClaim } from '../../utils/utils';
import isEqual from 'lodash/isEqual';

interface DisplayClaimComponentProps {
  data: DisplayClaim;
  list: DisplayClaim[];
  mode: 'edit' | 'add';
  changeHandler: (val: any) => void;
}

function DisplayClaimComponent({ data, list, mode, changeHandler }: DisplayClaimComponentProps) {
  const [origData, setOrigData] = useState<DisplayClaim>(init_DisplayClaim());
  const [modifiedData, setModifiedData] = useState<DisplayClaim>(init_DisplayClaim());
  const [newClaim, setNewClaim] = useState<Claim>(init_Claim());
  const [hasError, setError] = useState<boolean>(false);
  const [newClaimSelection, setNewClaimSelection] = useState<string>('selectExisting');
  const [filteredList, setFilteredList] = useState<OptionProps[]>([]);
  const allClaimsDropdownList = useSelector(getClaimsDropdownList);
  const allClaims = useSelector(getClaims);
  const classes = gritComponentStyles();

  useMemo(() => {
    setOrigData(data);
  }, [data]);

  useEffect(() => {
    isEqual(origData, modifiedData) ? setError(true) : setError(false);
  }, [modifiedData]);

  useEffect(() => {
    if (newClaim['userInputType'] === 'Paragraph') setModifiedData({ ...modifiedData, required: false });
    setError(validateClaim(newClaim, allClaims));
  }, [newClaim]);

  useEffect(() => {
    if (mode === 'edit') {
      setModifiedData(data);
      setError(false);
    }
    if (mode === 'add') {
      setModifiedData(init_DisplayClaim());

      if (newClaimSelection === 'selectExisting' && allClaimsDropdownList.length > 0) {
        const availableList = (list || []).reduce(
          (acc: string[], curVal: DisplayClaim) => acc.concat([curVal.claimTypeReferenceId]),
          [],
        );
        const _temp = allClaimsDropdownList
          .filter((el: OptionProps) => !availableList.includes(el.value))
          .sort((a: OptionProps, b: OptionProps) => (a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1));
        setFilteredList(_temp);
        _temp.length === 0 ? setError(true) : setError(false);
      }
      if (newClaimSelection === 'addNew') {
        setError(true);
      }
    }
  }, [data, list, mode, newClaimSelection, allClaimsDropdownList]);

  useEffect(() => {
    filteredList.length > 0 && setModifiedData({ ...modifiedData, claimTypeReferenceId: filteredList[0].value });
  }, [filteredList]);

  return (
    <>
      {mode === 'add' && (
        <div id="add-claimTypeReferenceId">
          <FormControl>
            <RadioGroup
              row
              value={newClaimSelection}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setNewClaimSelection(e.target.value);
              }}
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
            >
              <FormControlLabel
                value="selectExisting"
                control={<Radio />}
                label="Select from existing claimTypeReferenceId"
              />
              <FormControlLabel value="addNew" control={<Radio />} label="Add a new Claim" />
            </RadioGroup>
          </FormControl>
          <hr />
        </div>
      )}
      {modifiedData && (
        <div className={classes.flexCol}>
          <div>
            {mode === 'edit' && <ShowClaimComponent data={allClaims[modifiedData.claimTypeReferenceId]} />}
            {mode === 'add' && newClaimSelection === 'selectExisting' && (
              <>
                {filteredList.length > 0 && (
                  <SelectComponent
                    changeHandler={(e: SelectChangeEvent<string>) => {
                      setModifiedData({ ...modifiedData, claimTypeReferenceId: e.target.value });
                    }}
                    data={{
                      value: modifiedData['claimTypeReferenceId'] || filteredList[0]['value'],
                      label: 'Select ClaimTypeReferenceId',
                      style: { margin: 1, width: 400 },
                      options: filteredList,
                    }}
                  />
                )}
                {filteredList.length === 0 && <div>There are no existing claim. Please add a new claim.</div>}
              </>
            )}
            {mode === 'add' && newClaimSelection === 'addNew' && (
              <ClaimComponent
                data={newClaim}
                changeHandler={(newClaim: Claim) => {
                  setNewClaim(newClaim);
                }}
              />
            )}
          </div>
          <div>
            <FormControlLabel
              sx={{ m: 0 }}
              label="required"
              control={
                <Checkbox
                  checked={modifiedData['required'] || false}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setModifiedData({ ...modifiedData, required: !modifiedData['required'] });
                  }}
                />
              }
            />
          </div>
          <footer className={classes.footer}>
            <Button
              variant="contained"
              color="primary"
              disabled={hasError}
              onClick={() => {
                if (mode === 'add' && newClaimSelection === 'selectExisting')
                  changeHandler({
                    ioclaim: { ...modifiedData, claimTypeReferenceId: modifiedData['claimTypeReferenceId'] },
                    claim: {},
                  });
                else if (mode === 'add' && newClaimSelection === 'addNew')
                  changeHandler({
                    ioclaim: { ...modifiedData, claimTypeReferenceId: newClaim['id'] },
                    claim: newClaim,
                  });
                else changeHandler({ ioclaim: modifiedData });
              }}
            >
              {mode === 'add' ? 'Add' : 'Update'}
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={() => {
                changeHandler(null);
              }}
            >
              Cancel
            </Button>
          </footer>
        </div>
      )}
    </>
  );
}

// export default withAITracking(reactPlugin, DisplayClaimComponent);
export default DisplayClaimComponent;
